var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1629 6.83709C23.529 7.2032 23.529 7.79677 23.1629 8.16292L8.16292 23.1629C7.79677 23.529 7.2032 23.529 6.83709 23.1629C6.47097 22.7968 6.47097 22.2032 6.83709 21.8371L21.8371 6.83709C22.2032 6.47097 22.7968 6.47097 23.1629 6.83709Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.83709 6.83709C7.2032 6.47097 7.79677 6.47097 8.16292 6.83709L23.1629 21.8371C23.529 22.2032 23.529 22.7968 23.1629 23.1629C22.7968 23.529 22.2032 23.529 21.8371 23.1629L6.83709 8.16292C6.47097 7.79677 6.47097 7.2032 6.83709 6.83709Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.e101816fc55c39ade177904fdbe2ac7f.svg";
export { ForwardRef as ReactComponent };